import { StatusChip, type Tone } from '@nyce/admin-kit/console';
import type { ProdRun, RunStatus } from './api/prodstats';

const RUN_TONE: Record<RunStatus, Tone> = {
  queued: 'blue',
  running: 'blue',
  succeeded: 'green',
  failed: 'red',
  cancelled: 'grey',
};

/** A run's state; a run that left databases out shows how many. */
export function RunChip({ run }: { run: Pick<ProdRun, 'status' | 'databasesFailed'> }) {
  const partly = run.status === 'succeeded' && run.databasesFailed > 0;
  return (
    <StatusChip
      value={run.status}
      tone={partly ? 'amber' : RUN_TONE[run.status]}
      label={partly ? `${run.databasesFailed} failed` : run.status}
    />
  );
}
